import React, { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { globalHistory } from "@reach/router";

export const AppContext = createContext({});

const AppProvider = ({ children }) => {
  const [activeBundles, setActiveBundles] = useState([]);
  const [activeRetainers, setActiveRetainers] = useState([]);
  const [activeServices, setActiveServices] = useState([]);
  const [aLaCarte, setALaCarte] = useState([]);
  const [bundles, setBundles] = useState([]);
  const [monogamyPlan, setMonogamyPlan] = useState(null);
  const [cartActive, setCartActive] = useState(false);
  const [mobileCartOpen, setMobileCartOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [headerHelperDeleting, setHeaderHelperDeleting] = useState(false);
  const [pathname, setPathname] = useState(null);

  //

  const [headerBgColor, setHeaderBgColor] = useState(`transparent`);
  const [headerFgColor, setHeaderFgColor] = useState(`orange`);
  const [headerButtonColor, setHeaderButtonColor] = useState({
    background: `orange`,
    text: `white`
  });

  const [scrolled, setScrolled] = useState(false);
  const [headerHovered, setHeaderHovered] = useState(false);
  const [navigating, setNavigating] = useState(false);
  //

  useEffect(() => {
    if (window) {
      setPathname(window.location.pathname);
    }

    return globalHistory.listen(({ location }) => {
      setPathname(location.pathname);
    });
  }, []);

  const toggleBundle = bundle => {
    if (!activeBundles.includes(bundle)) {
      setActiveBundles([...activeBundles, bundle]);
    } else {
      const activeBundleIndex = activeBundles.indexOf(bundle);

      if (activeBundleIndex !== -1) {
        const bundles = JSON.parse(JSON.stringify(activeBundles));

        bundles.splice(activeBundleIndex, 1);

        setActiveBundles(bundles);
      }
    }
  };

  const toggleRetainer = retainer => {
    if (!activeRetainers.includes(retainer)) {
      setActiveRetainers([...activeRetainers, retainer]);
    } else {
      const activeRetainerIndex = activeRetainers.indexOf(retainer);

      if (activeRetainerIndex !== -1) {
        const retainers = JSON.parse(JSON.stringify(activeRetainers));

        retainers.splice(activeRetainerIndex, 1);

        setActiveRetainers(retainers);
      }
    }
  };

  const toggleService = service => {
    if (!activeServices.includes(service)) {
      setActiveServices([...activeServices, service]);
    } else {
      const activeServiceIndex = activeServices.indexOf(service);

      if (activeServiceIndex !== -1) {
        const services = JSON.parse(JSON.stringify(activeServices));

        services.splice(activeServiceIndex, 1);

        setActiveServices(services);
      }
    }
  };

  //

  return (
    <AppContext.Provider
      value={{
        activeBundles,
        setActiveBundles,
        aLaCarte,
        setALaCarte,
        bundles,
        setBundles,
        monogamyPlan,
        setMonogamyPlan,
        cartActive,
        setCartActive,
        toggleBundle,
        activeRetainers,
        setActiveRetainers,
        toggleRetainer,
        activeServices,
        setActiveServices,
        toggleService,
        headerHelperDeleting,
        setHeaderHelperDeleting,
        mobileCartOpen,
        setMobileCartOpen,
        mobileMenuOpen,
        setMobileMenuOpen,
        pathname,
        headerBgColor,
        setHeaderBgColor,
        headerFgColor,
        setHeaderFgColor,
        headerButtonColor,
        setHeaderButtonColor,
        scrolled,
        setScrolled,
        headerHovered,
        setHeaderHovered,
        navigating,
        setNavigating
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

AppProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default AppProvider;
